import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { useFormikContext } from "formik";
import { selectAllRegistration } from "../../../redux/slices/registrationSlice";
import { selectHasParentRegistration } from "../../../redux/slices/appSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import ParticipantDetails from "./ParticipantDetails";

const ConnectedParticipantDetails = ({ controlId }) => {
    const {
        ENUMS: { DefaultView, Status },
    } = constants;

    const { values } = useFormikContext();
    const { Managed_By_Primary = false } = values;

    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const { currentRegistration } = useSelector(selectAllRegistration);

    const isAdditionalParticipant = currentRegistration > 0;
    const isChildParticipant = isAdditionalParticipant || hasParentRegistration;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );
    const {
        options: { general, participantdetails },
    } = control;

    const { phoneFieldsType } = useSelector(selectAllP2pSettings);

    const isManagedByPrimary = isChildParticipant && Managed_By_Primary;

    const shouldDisplayPhone =
        phoneFieldsType === Status.OPTIONAL ||
        phoneFieldsType === Status.REQUIRED;

    const phoneInputOptional =
        phoneFieldsType === Status.OPTIONAL ? "Optional" : "";

    const participantDetailsProps = {
        isChildParticipant,
        isManagedByPrimary,
        phoneInputOptional,
        shouldDisplayPhone,
        ...general,
        ...participantdetails,
    };
    return <ParticipantDetails {...participantDetailsProps} />;
};

ConnectedParticipantDetails.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedParticipantDetails;
